module.exports = __webpack_public_path__ + "static/media/ace_security.acacd633.png";